import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const ErrorMessage = ({ error }) => {
  const status = error.status || 500;
  const message = error.message || 'Unknown error';
  const currentUser = useSelector(({ user }) => user);
  const shouldMaskError = status >= 500 && !currentUser;
  return shouldMaskError
    ? "We're sorry, an unexpected error has occurred. We've already reported it to our developers. Please come back later."
    : message.split('\n').map((currentMmessage) => <p key={currentMmessage}>{currentMmessage}</p>);
};

ErrorMessage.propTypes = {
  error: PropTypes.shape().isRequired,
};

export default ErrorMessage;
